import { render, staticRenderFns } from "./AppHeaderAuthorized.vue?vue&type=template&id=da27b8cc&scoped=true"
import script from "./AppHeaderAuthorized.vue?vue&type=script&lang=js"
export * from "./AppHeaderAuthorized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da27b8cc",
  null
  
)

export default component.exports